import React, {useEffect, useState, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {isEmpty} from 'lodash';
import styled from 'styled-components';
import { i18n } from '../../../translate/i18n';
import {
  Typography,
  IconButton,
  FormControl,
  TextField
} from '@mui/material';
import {withRouter} from 'react-router-dom';

import CloseIcon from '@mui/icons-material/Close';
import * as actions from '../../../store/actions';

import {
  FormStyled,
  DoneIconStyled,
  DivSubmitButtons,
  DivFormTitle,
} from '../Forms/styles';

import Autocomplete from '../../../UI/Autocomplete/Autocomplete';
import Spinner from '../../../components/Spinner/index';


const ModalCloneEquipmentModel = (props) => {
  const dispatch = useDispatch();

  // parametros para busca do autocomplete
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [orderBy, setOrderBy] = useState('name');
  const [order, setOrder] = useState('asc');

  const [name, setName] = useState('');
  const [description, setDescription] = useState('')

  // selected values on autocomplete
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [searchTextGroups, setSearchTextGroups] = useState("")
  const [groupsFormated, setGroupsFormated] = useState([])

  //error forms
  const [nameError, setNameError] = useState(false);
  const [groupsError, setGroupsError] = useState(false);

  // fetch from BE
  const fetchGroups = useCallback(
    () => dispatch(actions.fetchGroups(page, limit, searchTextGroups, order, orderBy)),
    [page, limit, searchTextGroups, order, orderBy]
  );

  // get from redux
  const equipmentModel = useSelector(state => state.equipmentModels.equipmentModel);
  const groups = useSelector(state => state.groups.groups);

  const loadingEquipmentModels = useSelector(state => state.equipmentModels.loading);
  const loadingGroups = useSelector(state => state.groups.loading);
  const loadingClone = useSelector(state => state.equipmentModels.loadingClone);

  // post to BE
  const postCloneEquipmentModels = (body, id) =>
    dispatch(actions.postCloneEquipmentModels(body, id));

  //FUNCTION TO FORMAT TYPES IN THE AUTOCOMPLETE
  useEffect(() => {
    const dataFromRedux = groups
    let returnArray = [];
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
    setGroupsFormated(returnArray)
  }, [groups])

  useEffect(() => {
    fetchGroups(page, limit, searchTextGroups, order, orderBy);
  }, [searchTextGroups]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loadingClone) return;
    let hasError = false;

    if(!name) {
      setNameError(true);
      hasError = true;
    }

    if (isEmpty(selectedGroups)) {
      setGroupsError(true);
      hasError = true;
    }

    if (hasError) return;

    const body = {
      "name": name,
      "description": description,
      "equipmentGroup": selectedGroups.value,
    }

    postCloneEquipmentModels(body, props.idEquipToBeCloned).then((result) => {
      if (result !== 'error') {
        props.closeModal();
      }
    })

  };

  const handleInputChangeSelectorGroups = (text) => {
    setSearchTextGroups(text);
  }

  const handleInputChangeGroups = selected => {
    setGroupsError(false);
    setSelectedGroups(selected)
  }


  const styles = {
    opacityContainer: {
      opacity: loadingClone ? '0.3' : '1',
      position: 'relative',
    },
    groupContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      marginLeft: 5,
      cursor: 'pointer',
      fontSize: '1.5rem',
    },
    groupLabel: {
      fontWeight: 'bold',
    },
    createButton: {
      marginLeft: 20,
      background: '#bbd2ca',
      border: 'none',
      fontSize: 11,
      fontWeight: 400,
      borderRadius: 15,
      padding: '5px 10px 5px 10px',
      cursor: 'pointer',
    }
  };

  return <>
    <FormStyled onSubmit={handleSubmit} style={styles.opacityContainer}>
    {loadingClone && <Spinner overlay />}
      <DivFormTitle>
        <Typography variant="h6">
          {i18n.t('typographyModalCloneEquipModel.text')} {equipmentModel.name}
        </Typography>

      </DivFormTitle>

      <FormControl variant="standard" fullWidth>
        <TextField
          variant="standard"
          multiline
          label={i18n.t('textFieldModalCloneEquipModel.name')}
          name='name'
          onChange={event => { setNameError(false); return setName(event.target.value.toUpperCase()) }}
          value={name}
          margin='normal'
          error={nameError} />
      </FormControl>

      <FormControl variant="standard" fullWidth margin='normal'>
        <Autocomplete
          loading={loadingGroups} //sent to isLoading
          label={i18n.t('autocompleteModalCloneEquipModel.group')}
          data={groupsFormated} // sent to options
          onSelectValue={handleInputChangeGroups} // sent to onChange
          valueSelected={selectedGroups} // sent to value
          newSearchText={handleInputChangeSelectorGroups}
          name='group'
          hasError={groupsError}
        />
      </FormControl>

      <FormControl variant="standard" fullWidth>
        <TextField
          variant="standard"
          multiline
          label={i18n.t('textFieldModalCloneEquipModel.description')}
          name='description'
          onChange={event => { return setDescription(event.target.value.toUpperCase()) }}
          value={description}
          margin='normal' />
      </FormControl>

      <DivSubmitButtons>
        <IconButton onClick={() => props.closeModal()} size="large">
          <CloseIcon fontSize="large" color="error" />
        </IconButton>
        <IconButton type="submit" size="large">
          <DoneIconStyled fontSize="large" />
        </IconButton>
      </DivSubmitButtons>
    </FormStyled>

  </>;
};

export default withRouter(ModalCloneEquipmentModel);

const TypographyHover = styled(Typography)`
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
